// Cargos que en Pedido de Productos actuan como otro cargo.
//
// El ANALISTA SR. DE OPERACIONES tiene fiscales asignados en la estructura y aprueba
// sus pedidos como jefatura. Solo aplica a las pantallas de pedidos; el backend hace
// lo mismo para las rutas pedido-productos/ (CARGOS_ALIAS_POR_RUTA en api/modulos/views.py).

export const CARGOS_COMO_JEFE_PEDIDO = ["ANALISTA SR. DE OPERACIONES"];

export const esCargoComoJefePedido = (cargo?: string | null) =>
  CARGOS_COMO_JEFE_PEDIDO.includes(String(cargo || "").trim().toUpperCase());

// Cargo con el que trabajan las pantallas de pedidos.
export const cargoParaPedido = (cargo?: string | null) =>
  esCargoComoJefePedido(cargo) ? "JEFE DE OPERACIONES" : String(cargo || "");
